import Chance from '../utils/Chance'
import Gold from './cards/Gold'
import Potion from './cards/Potion'
import Spell from './cards/Spell'
import GameBoard from './GameBoard'
import Hero from './Hero'
import MonsterFactory from './MonsterFactory'

export default class Game {
  boards: GameBoard[] = []
  currentBoardIndex = -1

  constructor(public hero: Hero, public width: number, public height: number) {
    this.nextBoard()
  }

  getCardGenerator(level = 1) {
    const weights = [67, 3, 15, 15]
    const generators = [
      () => MonsterFactory.createForLevel(level),
      () => new Gold(Chance.range(1, 8 + level * 2)),
      () => new Potion(Chance.range(3, 8 + level)),
      () => new Spell()
    ]

    return () => Chance.weighted(generators, weights)()
  }

  nextBoard() {
    const level = ++this.currentBoardIndex + 1
    const cardGenerator = this.getCardGenerator(level)
    const board = new GameBoard(this.width, this.height, this, cardGenerator)

    this.boards.push(board)
    return this.currentBoard
  }

  get currentBoard() {
    return this.boards[this.currentBoardIndex]
  }
}
